import React, { memo, useRef } from 'react'
import PropTypes from 'prop-types'

import Menu from './Menu'
import Edit from './Edit'
import List from './List'
import Delete from './Delete'

import './Popup.css'

const CLASS = 'insights-portal-subject-popup'

const arePropsEqual = (pre, cur) => pre.index === cur.index && pre.editor === cur.editor && pre.subject === cur.subject

const Popup = memo(props => {
  const targetRef = useRef()
  return (
    <div className={CLASS} ref={targetRef}>
      <Menu
        targetRef={targetRef}
        index={props.index}
        item={props.item}
        editor={props.editor}
        subject={props.subject}
        showImage={props.showImage}
        onEditorChange={props.onEditorChange}
      />
      <Edit
        targetRef={targetRef}
        index={props.index}
        editor={props.editor}
        subject={props.subject}
        subjects={props.subjects}
        onEditorChange={props.onEditorChange}
      />
      <List
        targetRef={targetRef}
        index={props.index}
        editor={props.editor}
        subject={props.subject}
        subjects={props.subjects}
        onEditorChange={props.onEditorChange}
      />
      <Delete targetRef={targetRef} index={props.index} editor={props.editor} onEditorChange={props.onEditorChange} />
    </div>
  )
}, arePropsEqual)

Popup.displayName = 'Popup'

Popup.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  item: PropTypes.object,
  editor: PropTypes.object,
  subject: PropTypes.object,
  subjects: PropTypes.object,
  showImage: PropTypes.any,
  onEditorChange: PropTypes.func
}

export default Popup
